// extracted by mini-css-extract-plugin
export default {"recipesColumn":"RecipesCategoryItem_recipesColumn__e16Au","columnHeader":"RecipesCategoryItem_columnHeader__adIzB","recipesList":"RecipesCategoryItem_recipesList__fl0g6"};